import React, { useState, useRef, useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
// import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import imgL1Hero from "../../assets/image/l5/png/l5-hero-img.png";
import imgDot from "../../assets/image/l5/png/l5-dot-shape.png";
// import Autocomplete from './Autocomplete'
import { usePlacesWidget } from "react-google-autocomplete";


const Widget = () => {
  const { ref, autocompleteRef } = usePlacesWidget({
    apiKey:"AIzaSyBxA_fGgH32pSiStAaitsGtF0WyxsiPLc8",
    onPlaceSelected: (place) => {
      console.log(place)
      // console.log(ref.current.value)
    },
    options:{
      componentRestrictions: { country: "us"},
      types: ["address"] 
    }
  });

  return <input id="auto-complete" class="form-control mb-4 required" ref={ref} placeholder="Address" required />
}

function formatPhoneNumber(value) {
  // if input value is falsy eg if the user deletes the input, then just return
  if (!value) return value;

  // clean the input for any non-digit values.
  const phoneNumber = value.replace(/[^\d]/g, "");

  // phoneNumberLength is used to know when to apply our formatting for the phone number
  const phoneNumberLength = phoneNumber.length;

  // we need to return the value with no formatting if its less then four digits
  // this is to avoid weird behavior that occurs if you  format the area code to early
  if (phoneNumberLength < 4) return phoneNumber;

  // if phoneNumberLength is greater than 4 and less the 7 we start to return
  // the formatted number
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }

  // finally, if the phoneNumberLength is greater then seven, we add the last
  // bit of formatting and return it.
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
    3,
    6
  )}-${phoneNumber.slice(6, 10)}`;
}

const Hero = () => {
  const [loading, setLoading] = useState(false);

  const [address, setAddress] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [time, setTime] = useState('zero-two-weeks');
  const [isValid, setIsValid] = useState(false);

  const [hasSubmitted, setHasSubmitted] = useState(false);

  const ref = useRef();
  
  const check = () => {
    const re = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
    const p = /^\([0-9]{3}\)[0-9]{3}-[0-9]{4}$/
    setIsValid(email && email?.match(re));
  }

  const onSubmit = async () => {
    const location = document.querySelector("#auto-complete")?.value

    setLoading(true);
    await fetch("https://hooks.zapier.com/hooks/catch/11480663/bmvg7j5/", {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'same-origin', // include, *same-origin, omit
      redirect: 'follow', // manual, *follow, error
      referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: JSON.stringify({
        address: location,
        email,
        phone,
        time
      }) // body data type must match "Content-Type" header
    })
    setLoading(false);
    setHasSubmitted(true);
  }

  useEffect(() => {
    check();
  }, [phone, address, email])

  return (
    <>
      {/* <!-- Hero Area --> */}
      <div className="position-relative bg-default-2 bg-pattern pattern-2 pt-20 pt-lg-32 pb-15 pb-lg-27">
        <Container>
          <Row className="justify-content-center align-items-center">
            <Col
              xs="9"
              md="7"
              lg="5"
              className="offset-xl-1 align-self-sm-end order-lg-2"
            >
              <div
                className="hero-img-custom position-relative"
                data-aos="fade-left"
                data-aos-duration="750"
                data-aos-delay="200"
              >
                <img style={{height: 500}} src={imgL1Hero} alt="" />
                <div
                  className="gr-abs-tl gr-z-index-n1"
                  data-aos="zoom-in"
                  data-aos-delay="1000"
                  data-aos-duration="1000"
                >
                  <img src={imgDot} alt="" />
                </div>
              </div>
            </Col>
            <Col
              xs="11"
              md="9"
              lg="7"
              xl="6"
              className="order-lg-1"
              data-aos="fade-right"
              data-aos-duration="750"
              data-aos-delay="500"
            >
              <div className="hero-content mt-11 mt-lg-0">
                <h1 className="title gr-text-2 mb-8 heading-color">
                  Want to sell your Brooklyn home fast?
                </h1>
                <div className="hero-btn mb-11">
                  {hasSubmitted? (
                    <>
                 <p className="gr-text-8 mb-11 pe-md-12 text-color-opacity">
                       Thank you for submitting your request for an offer. A representative will be in touch with you shortly.
                  </p>
                  <Button onClick={() => setHasSubmitted(false)}>Back</Button>
                  </>
                  ) : (
                    <>
                    <form >
                    <div style={{display: 'flex', flexDirection: 'column'}}>
                      <div class="form-group">
                        <Widget ref={ref}/>
                        {/* <GooglePlacesAutocomplete 
                        
                        apiKey="AIzaSyBxA_fGgH32pSiStAaitsGtF0WyxsiPLc8"
                        
                        selectProps={{
                          value:address,
                          onChange: e => setAddress(e),
                          placeholder: 'Address',
                          inputClassName: 'form-control',
                          // control: (provided) => ({
                          //   ...provided,
                          //   backgroundColor: 'green',
                          //   transition: 'all 100ms'
                          // }),
                        }}
                      
                        /> */}
                        {/* <Autocomplete /> */}
                       {/* <input type="text" name="address" placeholder="Address" class="mb-4 form-control"   value={address} onChange={e => setAddress(e.target.value)} /> */}
                      </div>
                      <div class="form-group mb-4">
                        <input required="true"  type="email" name="email" placeholder="Email"  class="form-control" value={email} onChange={e => setEmail(e.target.value)}/>      
                        <small style={{marginLeft: 4}} id="emailHelp" class="form-text text-muted ml-4">We'll never share your contact information with anyone else.</small>
                      </div>
                      <div class="form-group">
                      <input type="tel" name="phone-number" placeholder="Phone Number" class="mb-4 form-control" value={phone} onChange={e => setPhone(formatPhoneNumber(e.target.value))}/>
                      </div>
                      {/* <LocationSearchInput /> */}
                      {/* <!-- checkbox handle -->  */}
                      {/* <!-- radio button handle -->  */}
                      {/* <!-- select field handle -->  */}
                      <div class="form-group" style={{display: 'flex', flexDirection: 'column'}}>
                      <label class="required" for="time-to-submit">How soon do you want to sell your home?</label>
                      <select id="time-to-submit" name="time-to-submit" class="form-control mb-4" value={time} onChange={(e) => setTime(e.target.value)}>
                          <option value="zero-two-weeks">0-2 weeks</option>
                          <option value="two-four-weeks">2-4 weeks</option>
                          <option value="four-weeks">4+ weeks</option>
                      </select>
                      </div>
                      {/* <button type="submit">Send</button> */}
                      <Button disabled={!isValid} className="gr-hover-shadow-4 hover-underline mb-4" onClick={onSubmit}>
                        {loading ? (
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        ) : "Get offer"}
                      </Button>
                      </div>
                  </form>
                                 <p className="gr-text-8 mb-11 pe-md-12 text-color-opacity">
                                 No matter what condition your home is in, we'd love to work with you.
                               </p>

                               </>
                  )}
  
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Hero;
